module.exports = __webpack_public_path__ + "img/icon_menu1.51ec2496.png";